import { Component, OnInit } from '@angular/core';
import { Company } from 'api/models';
import { AlertController, ViewController, NavParams, ToastController } from 'ionic-angular';
import { MeteorObservable, ObservableCursor } from 'meteor-rxjs';
import { App } from "ionic-angular";
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
// import { subscribeActiveCompany, subscribeActiveCompanyAdmins, getCompany, getCompanyAdmins } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';

@Component({
  selector: 'edit-company-info',
  templateUrl: 'edit-company-info.html'
})

export class EditCompanyInfoComponent implements OnInit {
  company?: Company | void;
  zipMask: Array<string|RegExp>;
  phoneMask: Array<string|RegExp>;

  constructor(
    private _app: App,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    public httpService: HttpService,
    public companyService: CompanyService
  ) {
    this.zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
    const companyId = this.navParams.get('companyId');
    MeteorObservable.autorun().subscribe(() => {
      if (companyId) {
        this.company = this.companyService.getCompany(companyId);
      } else {
        this.company = this.companyService.subscribeActiveCompany();
      }
    });
  }
  eventHandler(keyCode){
    if(keyCode==13){
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }
  save(): void {
    if (!this.company) {
      return;
    }
    /*
    MeteorObservable.call('updateCompany', this.company._id, {
      name: this.company.name,
      code: this.company.code,
      town: this.company.town,
      state: this.company.state,
      zipCode: (this.company.zipCode || '').replace(/[^\d]/g, ''),
      phoneNumber: (this.company.phoneNumber || '').replace(/[^\d]/g, ''),
      address: this.company.address,
      country: this.company.country
    })
    .subscribe({
      next: () => {
        this.viewCtrl.dismiss(true);
      },
      error: (e: Error) => {
        // this.handleError(e);
      }
    });
    */

    this.httpService.MeteorCall(
      'updateCompany',
      this.company._id,
      {
        name: this.company.name,
        code: this.company.code,
        town: this.company.town,
        state: this.company.state,
        zipCode: (this.company.zipCode || '').replace(/[^\d]/g, ''),
        phoneNumber: (this.company.phoneNumber || '').replace(/[^\d]/g, ''),
        address: this.company.address,
        country: this.company.country
      }
    ).then(() => {
      this.viewCtrl.dismiss(true);
    })
    .catch((e: Error) => {
      // this.handleError(e);
    });
  }


  showError(title: string, message: string): void {
    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message,
      title: title || 'Oops',
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/edit-company-info/edit-company-info.ts